<div class="loginPage">
  <div class="logincontainer">
    <div class="login-top">
      <img
        class="app-logo"
        alt="Chevron Logo"
        src="../../../../assets/images/hallmark.png"
      />
      <div class="headingText">EMDM</div>
    </div>
    <div class="login-bottom">
      <input value="Login with your corporate id" class="LoginBtn" (click)="LoginUser()"/>
    </div>
  </div>
</div>
<!-- <link rel="stylesheet" href="styles.css"> -->